// extracted by mini-css-extract-plugin
export default {"screenNameBar":"styles_screenNameBar__c9HsB","backButtom":"styles_backButtom__kDTpF"};